var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 17.391C0.751544 15.1244 1.89011 13.0097 3.78149 11.7606C5.67287 10.5115 8.06476 10.2945 10.15 11.183",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 9.14062C9.77817 9.14062 11.625 7.2938 11.625 5.01562C11.625 2.73745 9.77817 0.890625 7.5 0.890625C5.22183 0.890625 3.375 2.73745 3.375 5.01562C3.375 7.2938 5.22183 9.14062 7.5 9.14062Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18.1406C18.0784 18.1406 18.75 17.4691 18.75 16.6406C18.75 15.8122 18.0784 15.1406 17.25 15.1406C16.4216 15.1406 15.75 15.8122 15.75 16.6406C15.75 17.4691 16.4216 18.1406 17.25 18.1406Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5233 10.8408L18.9653 12.2938C19.1167 12.7942 19.6298 13.0919 20.1393 12.9748L21.6113 12.6338C22.184 12.5047 22.774 12.7638 23.0666 13.2727C23.3591 13.7817 23.2861 14.4219 22.8863 14.8518L21.8553 15.9628C21.4984 16.3466 21.4984 16.941 21.8553 17.3248L22.8863 18.4358C23.2861 18.8657 23.3591 19.5059 23.0666 20.0149C22.774 20.5238 22.184 20.7829 21.6113 20.6538L20.1393 20.3128C19.6298 20.1957 19.1167 20.4934 18.9653 20.9938L18.5233 22.4408C18.3546 23.0035 17.8368 23.3889 17.2493 23.3889C16.6619 23.3889 16.144 23.0035 15.9753 22.4408L15.5333 20.9878C15.382 20.4874 14.8688 20.1897 14.3593 20.3068L12.8873 20.6478C12.3146 20.7769 11.7246 20.5178 11.4321 20.0089C11.1395 19.4999 11.2126 18.8597 11.6123 18.4298L12.6433 17.3188C13.0003 16.935 13.0003 16.3406 12.6433 15.9568L11.6123 14.8458C11.2126 14.4159 11.1395 13.7757 11.4321 13.2667C11.7246 12.7578 12.3146 12.4987 12.8873 12.6278L14.3593 12.9688C14.8688 13.0859 15.382 12.7882 15.5333 12.2878L15.9753 10.8348C16.1453 10.2725 16.6641 9.88827 17.2515 9.88965C17.839 9.89104 18.356 10.2777 18.5233 10.8408V10.8408Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.b2d26db0b7a44a1f2fedd4ad50a4cd6b.svg";
export { ForwardRef as ReactComponent };